/**
 * Formas de los datos que viven en Realtime Database.
 *
 * Todo lo que se lee de RTDB es dato no confiable: puede venir de una versión
 * anterior del cliente, de una escritura a medias, o de alguien tocando la consola.
 * Por eso estos tipos solo describen la forma esperada; validarlos es trabajo de
 * los parsers de `./guards.ts`, y no hay ni un `as` en el camino.
 */
export const SESSION_STATES = [
    'offering',
    'answered',
    'connected',
    'closed',
];
/** Convierte un candidato del navegador a su forma en RTDB, quitando los `null`. */
export function toIceCandidatePayload(candidate) {
    const payload = { candidate: candidate.candidate };
    if (candidate.sdpMid !== null)
        payload.sdpMid = candidate.sdpMid;
    if (candidate.sdpMLineIndex !== null)
        payload.sdpMLineIndex = candidate.sdpMLineIndex;
    if (candidate.usernameFragment !== null)
        payload.usernameFragment = candidate.usernameFragment;
    return payload;
}
/**
 * Servidores ICE por defecto.
 *
 * Solo STUN, que basta en LAN y en la mayoría de NAT domésticos. En CGNAT y redes
 * corporativas hace falta TURN: eso llega en la fase 4, donde esto pasa a ser el
 * valor de reserva de un archivo de configuración.
 */
export const DEFAULT_ICE_SERVERS = [
    { urls: ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302'] },
];
//# sourceMappingURL=signaling.js.map